import {
    PENDINGLIST_COUNT_SUCCESS,
    PENDINGLIST_COUNT_FAILED,
    LOADING_PENDINGLIST_COUNT,
    RESET_PENDINGLIST_COUNT,
} from "../types";

const initialState = {
    isLoading: false,
    success: false,
    //failed: false,
    requestCount: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_PENDINGLIST_COUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                //failed: false,
                datarequestCount: "",
            };
        case PENDINGLIST_COUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                //failed: false,
                requestCount: action.payload.noOfRequest,
            };
        /*case PENDINGLIST_COUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                data: action.payload,
            };*/

        case RESET_PENDINGLIST_COUNT:
            return (state = initialState);

        default:
            return state;
    }
};